import { useGetHttp } from "../../http.hook";

interface IResponse {
    url: string;
}

export enum CampaignMetricsExportColumn {
  pageName = "pageName",
  profileLink = "profileLink",
  postLink = "postLink",
  dateOfPost = "dateOfPost",
  views = "views",
  likes = "likes",
  comments = "comments",
  shares = "shares",
  postStatus = "postStatus",
  postId = "postId",
  draftUrl = "draftUrl",
  campaignName = "campaignName",
  hourlyBreakdown = "hourlyBreakdown",
}

export function useExportCsvCampaignMetricsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:id/export-metrics",
  });
}
